import { useFieldArray } from 'react-hook-form';
import { EditInstallmentItem } from 'assets/js/pages/pledges/EditInstallmentItem';
import { PledgeFormValue } from 'assets/js/pages/pledges/usePledgeForm';
import { useGivebutterFormContext } from 'components/form';

const EditInstallments = () => {
    const { control } = useGivebutterFormContext<PledgeFormValue>();

    const installmentsFieldArray = useFieldArray({
        name: 'installments',
        control,
        keyName: 'fieldId',
    });

    const canRemove = installmentsFieldArray.fields.length > 1;

    return (
        <div className="flex flex-col gap-4">
            {installmentsFieldArray.fields.map((item, index) => (
                <EditInstallmentItem key={item.fieldId} canRemove={canRemove} index={index} />
            ))}
        </div>
    );
};

export { EditInstallments };
